import axios from "axios";

// axios.defaults.baseURL =
//   process.env.NODE_ENV === "production"
//     ? "https://lteapi.herokuapp.com/api"
//     : "http://localhost:8080/api";

//Ramanan
axios.defaults.baseURL =
  process.env.NODE_ENV === "production"
    ? "https://staginglteapi.letsteachenglishact.org/api"
    : "https://staginglteapi.letsteachenglishact.org/api"
    // : "http://localhost:8080/api";

    // Render URL 
    // https://lte-backend.onrender.com/api

const Axios = async (method, url, auth = false, data = null, token) => {
  const config = {
    method: method,
    url: url,
    headers: {
      "Content-Type": "application/json",
    },
    ...(token || {}),
  };

  if (auth) {
    config.headers.Authorization = `${sessionStorage.getItem("user_token")}`;
  }

  if (data) {
    config.data = data;
  }
  const onSuccess = (response) => response;

  const onError = (error) => {
    if (error.isAxiosError && !error.response) {
      return error.toJSON();
    }
    if (error.response) {
      return error.response;
    }
    return error;
  };

  try {
    const response = await axios(config);
    // console.log(response);
    return onSuccess(response);
  } catch (error) {
    return Promise.reject(onError(error));
  }
};

export default Axios;
